import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';

import { ListItemFilter } from '../local-types/ListItemFilter';

@Component({
  selector: 'app-list-filter',
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss']
})
export class ListFilterComponent {
  
  @Input() public itemsSource!: ListItemFilter[];
  @Output() public selectionChanged = new EventEmitter<number[]>();

  @ViewChildren(MatCheckbox)
  private checkboxOptions!: QueryList<MatCheckbox>;

  public filterList: number[] = [];

  public hasFilterSelected(): boolean {
    return this.filterList.length > 0;
  }

  public updateFilter(item: ListItemFilter, checked: boolean): void {
    if (checked) {
      this.filterList.push(item.id);
    } else {
      this.filterList = this.filterList.filter(x => x !== item.id);
    }
    this.selectionChanged.emit(this.filterList);
  }

  public clearFilters(): void {
    this.filterList = [];
    this.checkboxOptions.forEach(checkbox => checkbox.checked = false);
    this.selectionChanged.emit(this.filterList);
  }
}
